import { observer } from 'mobx-react'
import user from '@/stores/user'
import SJCard from '@/components/SJCard'
import SJCell from '@/components/SJCell'
import { couponList } from '@/services/payment'
import { CouponListRes } from '@/services/types/payment'
import { useEffect, useState } from 'react'
import SJAvatar from '@/components/SJAvatar'
import { getUserDevicesV2 } from '@/services/device'
import { DeviceRes, DevicesRes } from '@/services/types/device'
// import { Toast } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'
import SJSpace from '@/components/SJSpace'
import './index.less'

const Settings = () => {
  document.title = '设置'
  const navigate = useNavigate()

  const handleListCell = (urlStr: string) => {
    console.log('handleListCell')
    navigate(urlStr)
  }

  // 请求优惠券列表
  const [couponAmount, setCouponAmount] = useState(0)
  const fetchCouponList = async () => {
    try {
      const res = (await couponList()) as unknown as CouponListRes
      setCouponAmount(res.total)
    } catch (error) {}
  }
  const [devices, setDevices] = useState<DeviceRes[]>()
  // 请求设备列表
  const fetchDeviceList = async () => {
    try {
      const res = (await getUserDevicesV2()) as unknown as DevicesRes
      setDevices(res.list)
    } catch (error) {}
  }
  useEffect(() => {
    fetchCouponList()
    fetchDeviceList()
  }, [])

  const goDevice = () => {
    if (!devices) return
    if (devices.length === 1) {
      // Taro.navigateTo({
      //   url: `/packageDevice/pages/detail/index?id=${devices[0].deviceId}&groupId=${devices[0].groupId}&gUserId=${user.userDefaultGid}&from=settings`,
      // })
    } else {
      navigate('/device/list')
    }
  }

  // const checkDevice = () => {
  //   if (!user.hasDevice) {
  //     Toast.show('请先配置机器人')
  //     return false
  //   } else {
  //     return true
  //   }
  // }

  const goPlayer = () => {
    // if (!checkDevice()) return
    // Taro.navigateTo({
    //   url: `/packagePlayers/pages/playerDetail/index?groupId=${user.userDefaultGroupId}&playerId=${user.userPlayer.playerId}&roleType=1&from=settings`,
    // })
    navigate('/player/detail', { state: {} })
  }

  return (
    <div className="page settings">
      <div className="main">
        <SJAvatar
          src={user.userPlayer.avatarUrl}
          name={user.userPlayer.name || '棋手'}
          onClick={goPlayer}
        />
        <div className="content">
          <SJCard>
            <SJCell title="设备管理" indicator onClick={goDevice}></SJCell>
            <SJCell
              title="棋手管理"
              indicator
              onClick={() => handleListCell(`/player`)}
              // onClick={() => handleListCell(`/packagePlayers/pages/playerList/index?groupId=${user.userDefaultGroupId}`)}
            ></SJCell>
          </SJCard>
          <SJSpace height={24} />
          <SJCard>
            <SJCell title="我的订单" indicator onClick={() => handleListCell('/order')}></SJCell>
            <SJCell
              title="我的优惠券"
              indicator
              detail={couponAmount ? `${couponAmount} 张` : ''}
              onClick={() => handleListCell('/coupon')}
            ></SJCell>
          </SJCard>
          <SJSpace height={24} />
          <SJCard>
            <SJCell title="帮助与反馈" indicator onClick={() => handleListCell('/help')}></SJCell>
            <SJCell title="关于" indicator onClick={() => handleListCell('/about')}></SJCell>
          </SJCard>
        </div>
      </div>
    </div>
  )
}

export default observer(Settings)
